import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'learning-band-table-modal',
    templateUrl: './learning-band-table-modal.component.html',
    styleUrls: ['./learning-band-table-modal.component.css'],
    standalone: false
})
export class LearningBandTableModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
